import { redirect } from 'react-router-dom'

export interface AuthLoaderDeps {
  sessionService: {
    getAccessToken(): string | null
    getAgentId(): string | null
    getExpiresAt(): number | null
    clearSession(): void
  }
}

/**
 * 基础登录校验 Loader 工厂
 */
export const createAuthLoader = (deps: AuthLoaderDeps) => async () => {
  const { sessionService } = deps
  const token = sessionService.getAccessToken()
  const agentId = sessionService.getAgentId()
  const expiresAt = sessionService.getExpiresAt()
  const isExpired = expiresAt === null || expiresAt <= Date.now()

  if (!token || !agentId || isExpired) {
    sessionService.clearSession()
    return redirect('/login')
  }

  return null
}

export interface NicknameLoaderDeps {
  sessionService: {
    getAgentId(): string | null
  }
  accountService: {
    getProfile(agentId: string): Promise<{ nickname?: string | null }>
  }
}

/**
 * 昵称设置校验 Loader 工厂
 * 在 authLoader 的基础上，进一步检查是否设置过昵称
 */
export const createNicknameLoader = (deps: NicknameLoaderDeps) => async () => {
  const { sessionService, accountService } = deps
  const agentId = sessionService.getAgentId()
  if (!agentId) return null

  try {
    const profile = await accountService.getProfile(agentId)

    if (!profile.nickname) {
      return redirect('/set-nickname')
    }
  } catch (error) {
    console.error('Nickname loader error:', error)
    throw error
  }

  return null
}
